import { useEffect, useRef, useState } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import { Helmet } from 'react-helmet-async';

import { Navigate, useNavigate, useParams } from 'react-router-dom';
// @mui
import { Stack, Paper, Button, Container, Typography, Grid, CircularProgress, Box, Modal } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { makeStyles } from '@material-ui/styles';

import './Calendar.css';
import ModalLayout from 'src/theme/Modal';
import {
  GetInterviewsHavetoTake,
  GetInterviewsList,
  GetInterviewsYouManage,
  GetMyTasks,
} from 'src/components/services/httpServices';

export default function MyCalendar() {
  let { id } = useParams();
  const navigate = useNavigate();
  const [TASKSLIST, setTasksList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [events, setEvents] = useState(null);

  const fetchData = async (event) => {
    const savedInterviews = await GetInterviewsHavetoTake();
    const savedInterviewsYouManage = await GetInterviewsYouManage();
    const savedMyTasks = await GetMyTasks();

    // const savedInterviews = await GetInterviewsList();
    console.log('savedMyTasks:', savedMyTasks);
    let interviews = [];
    if (savedInterviews !== null) {
      savedInterviews?.forEach((element) => {
        interviews.push(element.interview);
      });
    }
    var interviewsForCalender = [];

    interviews.forEach((element) => {
      let check = savedInterviewsYouManage?.findIndex((e) => e.id == element.id);
      console.log('check', check);
      if (check != -1) {
        savedInterviewsYouManage.splice(check, 1);
      }

      interviewsForCalender.push({
        id: element.id,
        title: `${element.interviewType} of ${element?.mstCandidate?.firstName} ${element?.mstCandidate?.lastName}`,
        // date: element.interviewDate,
        className: 'bg-Event',
        start: element.interviewDate.split('T')[0] + 'T' + element.interviewStart,
        end: element.interviewDate.split('T')[0] + 'T' + element.interviewEnd,
        candidateId: element.mstCandidateId,
        vacancyId: element.mstVacancyId,
        userId: element.userId,
        evaluated: element.evaluated,
      });
    });

    savedInterviewsYouManage.forEach((element) => {
      interviewsForCalender.push({
        id: element.id,
        title: `${element.interviewType} of ${element?.mstCandidate?.firstName} ${element?.mstCandidate?.lastName}`,
        // date: element.interviewDate,
        className: 'bg-Event',
        start: element.interviewDate.split('T')[0] + 'T' + element.interviewStart,
        end: element.interviewDate.split('T')[0] + 'T' + element.interviewEnd,
        candidateId: element.mstCandidateId,
        vacancyId: element.mstVacancyId,
        userId: element.userId,
        evaluated: element.evaluated,
      });
    });

    savedMyTasks.forEach((element) => {
      interviewsForCalender.push({
        id: element.id,
        title: `${element.activityName}`,
        // date: element.interviewDate,
        className: 'bg-EventTask',
        start: element.createdDate,
        end: element.deadLine,
        mstClientId: element.mstClientId,
        mstCompanyId: element.mstCompanyId,
      });
    });
    console.log('interviewsYoutake:', interviews);
    console.log('savedInterviewsYouManage:', savedInterviewsYouManage);
    console.log('interviewsForCalender:', interviewsForCalender);
    setEvents(interviewsForCalender);
    setLoading(false);
  };
  useEffect(() => {
    fetchData();
  }, []);
  const SaveCompany = async (event) => {};
  const [selectedEvent, setSelectedEvent] = useState(null);

  const handleEventClick = (eventInfo) => {
    console.log('extendedProps:', eventInfo.event._def.extendedProps);
    setSelectedEvent(eventInfo.event);
    console.log(eventInfo.event._def.publicId);
    let extendedProps = eventInfo.event._def.extendedProps;

    extendedProps.mstClientId != null
      ? navigate(`/app/ClientDetails/${eventInfo.event._def.publicId}/${extendedProps.mstClientId}/${true}`)
      : extendedProps.mstCompanyId != null
      ? navigate(`/app/CompanyDetails/${eventInfo.event._def.publicId}/${extendedProps.mstCompanyId}/${false}`)
      : navigate(`/app/InterviewDetail/${eventInfo.event._def.publicId}/${extendedProps.candidateId}`);

    setShow(true);
  };

  const handleModalClose = () => {
    setSelectedEvent(null);
  };
  const handleEventMouseEnter = (mouseEnterInfo) => {
    const eventEl = mouseEnterInfo.el;
    const eventTitle = mouseEnterInfo.event.title;
    // Create and attach a tooltip element
    const tooltip = document.createElement('div');

    tooltip.className = 'event-tooltip';

    tooltip.innerHTML = eventTitle;
    eventEl.appendChild(tooltip);
  };

  const handleEventMouseLeave = (mouseLeaveInfo) => {
    const eventEl = mouseLeaveInfo.el;
    // Remove the tooltip element
    const tooltip = eventEl.querySelector('.event-tooltip');
    if (tooltip) {
      eventEl.removeChild(tooltip);
    }
  };
  //console.log('company', company);
  return (
    <>
      <Helmet>
        <title> Calendar | Immigration System </title>
      </Helmet>
      {/* <Container> */}
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
        <Typography variant="h4" gutterBottom>
          Tasks & Scheduled Interviews
        </Typography>

        <Stack direction="row" spacing={2}>
          <span>Tasks:</span>
          <div
            style={{
              width: '20px',
              height: '20px',
              background: '#1fad1f',
              borderRadius: '50%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',

              // top: '-50px',
              // left: '50%',
              // transform: 'translateX(-50%)',
            }}
          ></div>
          <span>Interviews:</span>
          <div
            style={{
              width: '20px',
              height: '20px',
              background: '#ad1f22',
              borderRadius: '50%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',

              // top: '-50px',
              // left: '50%',
              // transform: 'translateX(-50%)',
            }}
          ></div>
        </Stack>
        {/* <Button
            onClick={() => {
              navigate(-1);
            }}
            variant="contained"
          >
            Back
          </Button> */}
      </Stack>
      {loading ? (
        <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
          <CircularProgress size={60} thickness={3} value={100} />
        </Grid>
      ) : (
        <Box
          p={4}
          m={6}
          component={Paper}
          boxShadow={3}
          sx={{ border: 0, borderColor: 'primary.main', borderRadius: '16px' }}
        >
          <FullCalendar
            plugins={[dayGridPlugin, timeGridPlugin]}
            initialView="dayGridMonth"
            events={
              events
              //   {
              //     id: '1',
              //     title: 'Ali Hassan Initial Interview1',
              //     // date: '2023-06-01',
              //     className: 'bg-Event',
              //     start: '2023-06-04T21:07',
              //     end: '2023-06-06T22:07',
              //     candidateId: '222',
              //   },

              //   {
              //     id: '2',
              //     title: 'Ali Hassan Initial Interview2',

              //     className: 'bg-Event',
              //     start: '2023-06-06T00:07',
              //     end: '2023-06-06T01:07',
              //   },
              //   {
              //     id: '5',
              //     title: 'Ali Hassan Initial Interview3',

              //     className: 'bg-Event',
              //     start: '2023-06-06T21:07',
              //     end: '2023-06-06T22:07',
              //   },
              //   {
              //     id: '6',
              //     title: 'Ali Hassan Initial Interview4',

              //     className: 'bg-Event',
              //     start: '2023-06-06T21:07',
              //     end: '2023-06-06T22:07',
              //   },
            }
            eventClick={handleEventClick}
            eventMouseEnter={handleEventMouseEnter}
            eventMouseLeave={handleEventMouseLeave}
            headerToolbar={{
              left: 'prev,next today',
              center: 'title',
              right: 'dayGridMonth,timeGridWeek,timeGridDay',
            }}
            editable={true}
            selectable={true}
            droppable={true}
            buttonText={{
              today: 'Today',
              month: 'Month',
              week: 'Week',
              day: 'Day',
              year: 'Year',
            }}
          />
        </Box>
      )}
      {/* </Container> */}
    </>
  );
}
